<template>
    <div v-bind:id="id" class="flex flex-row relative" @click="toggle">
        <div class="full flex flex-row">
            <div v-if="required" class="text-xl text-red-600">*</div>
            <Icon id="ck_icon" v-bind:source="image" :disabled="disabled" :width="checkbox_width" />
        </div>
        <div class="flex-grow pl-2 self-center h-full w-full">
            <span class="text-black font-thin text-lg">
                <slot></slot>
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Icon from "./Icon.vue";

export default defineComponent({
    name: "v-checkbox",
    components: {
        Icon,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        checked: {
            type: Boolean,
            required: false,
            default: false,
        },
        checkbox_width: {
            type:Number,
            required: false,
            default:28,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        required:{
            type: Boolean,
        },
        rating:{
            type: Boolean,
            required: false,
        }

    },
    data() {
        return {
            status: false,
            image: 'images/papsi_ck_off_icon.svg',
        }
    },
    mounted() {
        this.status = this.checked;
    },
    methods: {
        toggle() {
            if(this.disabled) {
                if(this.rating){
                   this.$emit("message");
                   this.status=true;
                }else{
                    this.$emit("message");
                    this.status=false;
                }
            } else {
                this.status = !this.status;
                this.setImage();
            }
            
        },
        setImage() {
            this.image = this.status ? 'images/papsi_ck_on_icon.svg' : 'images/papsi_ck_off_icon.svg';
        },
    },
    watch: {
        status(n : any) {
            this.setImage();
            this.$emit('changed', n);
        },
        checked(n : any) {
            this.status = n;
        },
    },
})
</script>

<style scoped>
.ckbox-dim {
    width: 28px !important;
    height: 28px !important;
}
.ckline-h {
    line-height: 25px !important;
}
</style>